<template>
    <div v-if="show" class="nevs-popup-container">
        <div class="nevs-popup">
            <div class="nevs-popup-text">
                <NevsTextField v-model="data.recipient" :label="$LANG.Get('fields.emailRecipient') + ':'"></NevsTextField>
                <NevsTextField v-model="data.subject" :label="$LANG.Get('fields.emailSubject') + ':'"></NevsTextField>
                <NevsTextArea v-model="data.body" :label="$LANG.Get('fields.emailBody') + ':'"></NevsTextArea>
            </div>
            <div class="nevs-popup-buttons">
                <NevsButton class="error" @click="cancelClick()">{{ $LANG.Get('buttons.cancel') }}</NevsButton>
                <NevsButton class="success" @click="sendClick()">{{ $LANG.Get('buttons.send') }}</NevsButton>
            </div>
        </div>
    </div>
</template>

<script>
import NevsButton from "@/components/nevs/NevsButton.vue";
import NevsTextArea from "@/components/nevs/NevsTextArea.vue";
import NevsTextField from "@/components/nevs/NevsTextField.vue";

export default {
    name: "ModalSmtpTest",
    components: {NevsTextArea, NevsTextField, NevsButton},
    props: {
        show: {
            type: Boolean,
            default: false
        }
    },
    emits: ['done'],
    data() {
        return {
            data: {
                recipient: '',
                subject: '',
                body: ''
            }
        }
    },
    watch: {
        show() {
            if (this.show) {
                this.data.recipient = '';
                this.data.subject = '';
                this.data.body = '';
            }
        }
    },
    methods: {
        cancelClick() {
            this.$emit('done', false);
        },
        sendClick() {
            let vm = this;
            this.$API.APICall('post', 'client/smtp-test', this.data, (data, success) => {
                if (success) {
                    vm.$LOCAL_BUS.TriggerEvent('popup', {text: vm.$LANG.Get('alerts.emailSent'), type: 'alert'});
                    vm.$emit('done', true);
                } else if (data && data.smtp_error) {
                    vm.$LOCAL_BUS.TriggerEvent('popup', {text: data.smtp_error, type: 'alert'});
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
            });
        }
    }
}
</script>
